import { Link, useParams } from 'react-router-dom';
import { useMarca } from '@/components/providers/MarcaProvider';
import { usePermissao } from '@/utils/permissao';

// Aviso no topo: teste grátis, pagamento pendente ou somente leitura. O link para Assinatura só aparece para o administrador
export const FaixaAssinatura = () => {
  const { situacao, diasTeste, acessoCompleto } = useMarca();
  const { tenant } = useParams();
  const admin = usePermissao('ADMIN');
  if (!situacao || situacao === 'ISENTA' || (situacao === 'ATIVA' && acessoCompleto)) return null;

  const texto = !acessoCompleto ? 'Acesso somente leitura: o teste ou a assinatura terminou.'
    : situacao === 'TESTE' ? `Teste grátis: ${diasTeste === 0 ? 'último dia' : `faltam ${diasTeste} dia${diasTeste === 1 ? '' : 's'}`}.`
    : situacao === 'ATRASADA' ? 'Pagamento pendente.'
    : situacao === 'CANCELADA' ? 'Assinatura cancelada: o acesso vai até o fim do período pago.' : '';
  const acao = !acessoCompleto || situacao === 'CANCELADA' ? 'Ativar assinatura' : situacao === 'ATRASADA' ? 'Ver cobrança' : 'Escolher forma de pagamento';

  return (
    <div role="status" className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2 text-sm ${acessoCompleto ? 'bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-100' : 'bg-red-50 text-red-900 dark:bg-red-950 dark:text-red-100'}`}>
      <span>{texto}</span>
      {admin ? <Link className="font-semibold underline" to={`/${tenant}/assinatura`}>{acao}</Link>
             : <span>Fale com o administrador da corretora.</span>}
    </div>
  );
};
